export default __webpack_public_path__ + "static/media/Elder Wand - Img - Wip 1_01.1f718a43.jpg";